// Single source of truth for the POS cart drawer's responsive layout,
// consumed by AppBarComp, Cart, CartStyles, FloatingFooter, ItemCards.
export const CART_DRAWER_WIDTH = 580;
export const CART_BREAKPOINT = "md"; // >= md (960px): persistent desktop cart
                                       // <  md: temporary full-width overlay

// Keep these in step with Footer.module.css / index.css so the category
// strip sits on top of the global Footer instead of covering it.
export const APP_HEADER_HEIGHT = 61;
export const APP_FOOTER_HEIGHT = 48;
export const APP_FOOTER_HEIGHT_XS = 58;
export const POS_CATEGORY_BAR_HEIGHT = 64;
export const POS_CATEGORY_BAR_HEIGHT_XS = 56;
